import React, {useContext} from "react";
import {Card, Typography, Box} from "@mui/material";
import {LocaleContext} from "../../contexts/localeContext";

interface CourseCardProps {
	title: string;
	description?: string;
	localizations?: Array<{
		title?: string;
		description?: string;
	}>;
	thumbnail: string;
	assignmentType?: string;
	dueDate?: string;
}

const CourseCard: React.FC<CourseCardProps> = ({title, description, localizations, thumbnail, assignmentType, dueDate}) => {
	const [localeState] = useContext(LocaleContext);
	const isSpanish = localeState.locale === "es" || localeState.locale === "es-419";

	// Use localizations if available and user is in Spanish, otherwise fall back to title and description
	const displayTitle = isSpanish && localizations && localizations.length > 0 && localizations[0]?.title ? localizations[0].title : title;
	const displayDescription = isSpanish && localizations && localizations.length > 0 && localizations[0]?.description ? localizations[0].description : description;
	return (
		<Card
			sx={{
				minWidth: 330,
				maxWidth: 260,
				flex: "0 0 auto",
				height: 380,
				borderRadius: 3,
				display: "flex",
				flexDirection: "column",
				overflow: "hidden",
				boxShadow: 2,
				m: 1,
				p: 1
			}}
		>
			{/* 2/3 upper: image */}
			<Box sx={{
				flex: 2,
				width: "100%",
				display: "flex",
				alignItems: "center",
				justifyContent: "center",
				background: "background.paper",
				overflow: "hidden",
				borderTopLeftRadius: 12,
				borderTopRightRadius: 12
			}}>
				<img
					src={thumbnail}
					alt={displayTitle}
					style={{
						width: "100%",
						height: "100%",
						objectFit: "fill",
						borderTopLeftRadius: 12,
						borderTopRightRadius: 12
					}}
				/>
			</Box>
			{/* 1/3 lower: info */}
			<Box sx={{flex: 1, width: "100%", p: "10px", display: "flex", flexDirection: "column", justifyContent: "center"}}>
				<Typography
					variant="h6"
					component="div"
					gutterBottom
					align="left"
					sx={{
						fontWeight: 600,
						whiteSpace: "normal",
						wordBreak: "break-word",
						overflowWrap: "break-word"
					}}
				>
					{displayTitle}
				</Typography>
				{displayDescription && (
					<Typography
						variant="body2"
						component="div"
						gutterBottom
						align="left"
						sx={{
							fontWeight: 400,
							fontSize: "1rem",
							whiteSpace: "normal",
							wordBreak: "break-word",
							overflowWrap: "break-word"
						}}
					>
						{displayDescription.length > 70 ? `${displayDescription.substring(0, 70)}...` : displayDescription}
					</Typography>
				)}
				<Typography variant="body2" align="left">
					{assignmentType}
					{assignmentType && dueDate && " • "}
					{dueDate && `Due: ${new Date(dueDate).toLocaleDateString()}`}
				</Typography>
			</Box>
		</Card>
	);
};

export default CourseCard;